module.exports = __webpack_public_path__ + "static/media/20210401_215137_058_IMG_0001.69354fdb.jpg";